import { render, staticRenderFns } from "./terms-and-conditions.page.vue?vue&type=template&id=7850b0f2&"
import script from "./terms-and-conditions.page.vue?vue&type=script&lang=js&"
export * from "./terms-and-conditions.page.vue?vue&type=script&lang=js&"
import style0 from "./terms-and-conditions.page.vue?vue&type=style&index=0&id=7850b0f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports